import {
  Alert,
  Box,
  Button,
  FormControlLabel,
  Snackbar,
  Switch,
} from "@mui/material";
import { GridApiCommunity } from "@mui/x-data-grid/models/api/gridApiCommunity";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import React, { useState } from "react";
import { useExportCV } from "../../../../hooks/useExportCV";

export const CustomExportButton = ({
  apiRef,
}: // handleClickOpen,
{
  apiRef: React.RefObject<GridApiCommunity>;
  // handleClickOpen: () => void;
}) => {
  const { exportCVsByIds, exportCVsByIdsAsDocx, isExporting } = useExportCV();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [includeName, setIncludeName] = useState(true);

  const getSelectedIds = (): string[] | null => {
    const selectedRows = Array.from(
      apiRef.current?.getSelectedRows()?.values() || []
    );

    if (selectedRows.length === 0) {
      setSnackbarOpen(true);
      return null;
    }

    return selectedRows.map((row) => row.id);
  };

  const handleExportPdf = async () => {
    const selectedIds = getSelectedIds();
    if (!selectedIds) return;
    await exportCVsByIds(selectedIds, includeName);
  };

  const handleExportDocx = async () => {
    const selectedIds = getSelectedIds();
    if (!selectedIds) return;
    await exportCVsByIdsAsDocx(selectedIds, includeName);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          border: "1px solid #ddd",
          borderRadius: 1,
          padding: "3px 8px 3px 12px",
          marginBottom: "5px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={includeName}
              onChange={(e) => setIncludeName(e.target.checked)}
              size="small"
            />
          }
          label={includeName ? "Include Name" : "Anonymized"}
        />
        <Button
          onClick={handleExportPdf}
          startIcon={<PictureAsPdfIcon />}
          variant="contained"
          size="small"
          sx={{ textTransform: "none" }}
        >
          {isExporting ? "Exporting..." : "Export PDF"}
        </Button>
        <Button
          onClick={handleExportDocx}
          startIcon={<ArticleOutlinedIcon />}
          variant="outlined"
          size="small"
          sx={{ textTransform: "none" }}
        >
          {isExporting ? "Exporting..." : "Export Word"}
        </Button>
      </Box>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity="warning"
          onClose={() => setSnackbarOpen(false)}
          sx={{ width: "100%" }}
        >
          Please select at least one CV to export.
        </Alert>
      </Snackbar>
    </>
  );
};
